import {attachModal} from '~/shared/components/ReduxModal';
import OtlPageComponent from '~/otlPage';

const OtlModal = (props: {
  closeModal?: () => void;
  args?: {
    onSuccess?: (() => void) | (() => Promise<void>);
    onClose?: () => void;
    onFailure?: () => void;
    showBackArrow?: boolean;
    showUnlinkButton?: boolean;
    hideLimitations?: boolean;
  };
}) => <OtlPageComponent {...props} />;

OtlModal.modalType = 'autoWidth';
OtlModal.hideCloseButton = true;
attachModal('otlModal', OtlModal);
